import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { InsertPersonComponent } from './insert-person.component';
import { CollectorModule } from '@nx-ahs/script-collector';
import { BaseTranslateModule } from '@nx-ahs/base-translate';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { LayoutModule } from '../../shared/components/layout/layout.module';

@NgModule({
	declarations: [InsertPersonComponent],
	exports: [InsertPersonComponent],
	imports: [
		CommonModule,
		IonicModule,
		CollectorModule,
		BaseTranslateModule,
		LayoutModule,
		FontAwesomeModule,
		FlexLayoutModule
	]
})
export class InsertPersonModule {}
